<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h1>Create Lesson</h1>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>General</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="title" class="col-md-2">Title *</label>
                  <div class="col-md-10">
                    <input
                      id="title"
                      v-model="entity.title"
                      type="text"
                      placeholder="Enter title"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="bio" class="col-md-2">Body *</label>
                  <div class="col-md-10">
                    <ckeditor id="body" v-model="entity.body" />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="summary" class="col-md-2">Summary</label>
                  <div class="col-md-10">
                    <ckeditor id="summary" v-model="entity.summary" />
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-12">
                    <div class="form-group row">
                      <label for="body" class="col-md-2 form-control-label">Files</label>
                      <div class="col-md-10">
                        <dropzone
                          v-if="dropzoneOptions"
                          id="files-uploader"
                          ref="dropzone"
                          class="dropzone-noprogress"
                          :options="dropzoneOptions"
                          @vdropzone-removed-file="filesChanged"
                          @vdropzone-file-added="filesChanged"
                        />
                        <div v-else>Dropzone can't work without upload url.</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="body" class="col-md-2">Lessons plan</label>
                  <div class="col-md-10">
                    <multiselect-remote
                      v-model="entity.lesson_plans"
                      :default-options="defaultOptions.docs"
                      :search-function="documentSearch"
                      label="title"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="body" class="col-md-2">Teacher's key</label>
                  <div class="col-md-10">
                    <multiselect-remote
                      v-model="entity.teachers_keys"
                      :default-options="defaultOptions.docs"
                      :search-function="documentSearch"
                      label="title"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="body" class="col-md-2">Activities/Worksheets</label>
                  <div class="col-md-10">
                    <multiselect-remote
                      v-model="entity.activities"
                      :default-options="defaultOptions.docs"
                      :search-function="documentSearch"
                      label="title"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="body" class="col-md-2">Audio</label>
                  <div class="col-md-10">
                    <multiselect-remote
                      v-model="entity.audio"
                      :default-options="defaultOptions.audio"
                      :search-function="audioSearch"
                      label="title"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="body" class="col-md-2">Overview</label>
                  <div class="col-md-10">
                    <multiselect-remote
                      v-model="entity.overviews"
                      :default-options="defaultOptions.docs"
                      :search-function="documentSearch"
                      label="title"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="body" class="col-md-2">Books</label>
                  <div class="col-md-10">
                    <multiselect-remote
                      v-model="entity.books"
                      :default-options="defaultOptions.docs"
                      :search-function="documentSearch"
                      label="title"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="body" class="col-md-2">Chapter Study Guides</label>
                  <div class="col-md-10">
                    <multiselect-remote
                      v-model="entity.chapter_study_guides"
                      :default-options="defaultOptions.docs"
                      :search-function="documentSearch"
                      label="title"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="body" class="col-md-2">Coloring Sheets</label>
                  <div class="col-md-10">
                    <multiselect-remote
                      v-model="entity.coloring_sheets"
                      :default-options="defaultOptions.docs"
                      :search-function="documentSearch"
                      label="title"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="published" class="col-md-2">Published</label>
                  <div class="col-md-10">
                    <input id="published" v-model="entity.published" type="checkbox">
                  </div>
                </div>

                <div class="form-group row">
                  <label for="featured" class="col-md-2">Featured Content</label>
                  <div class="col-md-10">
                    <select id="featured" v-model="entity.featured" class="form-control" name="featured">
                      <option v-for="(item, key) in $_featuredBlocksList" :key="item" :value="key">{{ item }}</option>
                    </select>
                  </div>
                </div>

                <div v-if="entity.featured" class="form-group row">
                  <label for="bio" class="col-md-2">Featured Summary</label>
                  <div class="col-md-10">
                    <ckeditor id="featured_body" v-model="entity.featuredBody" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>SEO</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="seo_title" class="col-md-2">Title</label>
                  <div class="col-md-10">
                    <input
                      id="seo_title"
                      v-model="entity.seo_title"
                      type="text"
                      placeholder="Enter SEO title"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Description</label>
                  <div class="col-md-10">
                    <textarea id="seo_desc" v-model="entity.seo_description" class="form-control" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <referencer
        @changeRefs="$_changeRefs"
      />

      <terms
        @changeTerms="$_changeTerms"
      />

      <div class="card">
        <div class="card-header">
          <strong>Path Alias</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="path_alias" class="col-md-2">{{ $config.app_api.host }}</label>
                  <div class="col-md-10">
                    <input
                      id="path_alias"
                      v-model="entity.path_alias"
                      type="text"
                      placeholder="Enter path alias"
                      class="form-control"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-5">
        <button class="btn btn-success" @click="save">
          Save
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Lesson has created successful!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div><!--/.row-->
</template>

<script>
import _ from 'lodash';
import Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.css';
import MultiselectRemote from '@/global/components/MultiselectRemote';
import Referencer from '@/global/components/Referencer';
import Terms from '@/global/components/TermsEditor';
import config from '../../../config';
// Mixins
import CreatePageMixin from '@/mixins/CreatePageMixin';
import DefaultOptionsRequests from '@/mixins/DefaultOptionsRequests';

export default {
  name: 'LessonNew',

  components: {
    dropzone: Dropzone,
    referencer: Referencer,
    terms: Terms,
    'multiselect-remote': MultiselectRemote,
  },

  mixins: [CreatePageMixin, DefaultOptionsRequests],

  data() {
    return {
      entity: {
        title: null,
        body: null,
        summary: null,
        files: [],
        audio: [],
        activities: [],
        teachers_keys: [],
        lesson_plans: [],
        overviews: [],
        books: [],
        chapter_study_guides: [],
        coloring_sheets: [],
        seo_title: '',
        seo_description: '',
        path_alias: '',
        published: true,
        featured: 0,
        featuredBody: '',
      },
      dropzoneOptions: {
        url: '/', // There are no link because we dont need to upload files immediately
        maxFiles: 50,
        maxFilesize: 100,
        addRemoveLinks: true,
        autoProcessQueue: false,
        accept() {},
      },
    };
  },

  mounted() {
    this.$_getDefaultDocuments();
    this.$_getDefaultAudio();
  },

  methods: {
    documentSearch: _.debounce((loading, search, vm, searchRequestId) => {
      const context = vm;
      vm.$apiHttp.get(`${vm.$config.app_api.prefix}content-types/media_doc?search_string=${escape(search)}`)
        .then((response) => {
          if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
          const newDataArr = _.cloneDeep(response.data);
          delete newDataArr.meta;
          context.options = Object.keys(newDataArr).map(e => newDataArr[e]);
          loading(false);
        })
        .catch((error) => {
          loading(false);
          console.error(error);
        });
    }, 350),
    audioSearch: _.debounce((loading, search, vm, searchRequestId) => {
      const context = vm;
      vm.$apiHttp.get(`${vm.$config.app_api.prefix}content-types/media_audio?search_string=${escape(search)}`)
        .then((response) => {
          if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
          const newDataArr = _.cloneDeep(response.data);
          delete newDataArr.meta;
          context.options = Object.keys(newDataArr).map(e => newDataArr[e]);
          loading(false);
        })
        .catch((error) => {
          loading(false);
          console.error(error);
        });
    }, 350),
    isEntityValid() {
      return this.$_validate([
        { name: 'Title', value: this.entity.title, type: 'required' },
        { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 },
        { name: 'Path Alias', value: this.entity.path_alias, type: 'path' },
        { name: 'Body', value: this.entity.body, type: 'required' },
      ]);
    },
    filesChanged() {
      this.entity.files = this.$refs.dropzone.dropzone.files;
    },
    saveRequest() {
      const postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('body', this.entity.body);
      // for (let i = 0; i < this.entity.files.length; i += 1) {
      //   postFormData.append('files[]', this.entity.files[i]);
      // }
      if (this.entity.files.length) {
        postFormData.append('chunkedFile', true);
      }
      for (let i = 0; i < this.entity.audio.length; i += 1) {
        postFormData.append('audio[]', this.entity.audio[i].id);
      }
      for (let i = 0; i < this.entity.activities.length; i += 1) {
        postFormData.append('activities[]', this.entity.activities[i].id);
      }
      for (let i = 0; i < this.entity.teachers_keys.length; i += 1) {
        postFormData.append('teachers_keys[]', this.entity.teachers_keys[i].id);
      }
      for (let i = 0; i < this.entity.lesson_plans.length; i += 1) {
        postFormData.append('lesson_plans[]', this.entity.lesson_plans[i].id);
      }
      for (let i = 0; i < this.entity.overviews.length; i += 1) {
        postFormData.append('overviews[]', this.entity.overviews[i].id);
      }
      for (let i = 0; i < this.entity.books.length; i += 1) {
        postFormData.append('books[]', this.entity.books[i].id);
      }
      for (let i = 0; i < this.entity.chapter_study_guides.length; i += 1) {
        postFormData.append('chapter_study_guides[]', this.entity.chapter_study_guides[i].id);
      }
      for (let i = 0; i < this.entity.coloring_sheets.length; i += 1) {
        postFormData.append('coloring_sheets[]', this.entity.coloring_sheets[i].id);
      }
      if (this.entity.featured) postFormData.append('featured', _.toNumber(this.entity.featured));
      if (this.entity.featuredBody) postFormData.append('featured_body', this.entity.featuredBody);
      return this.$apiHttp.post(`${this.$config.app_api.prefix}lessons`, postFormData);
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      const { files } = this.entity;
      const { prefix, host } = this.$config.app_api;
      const token = JSON.parse(localStorage.getItem(config.tokenStorage.name));
      this.saveRequest().then((response) => {
        this.$_successSave();
        if (files && files.length) {
          this.$store.dispatch('uploadManager/startUpload', {
            apiHost: host,
            apiPrefix: prefix,
            entityId: response.data.id,
            files: [...files],
            token,
            contentType: response.data.content_type,
          });
        }
        this.$parent.getSource();
        window.location.hash = `#/admin/content/lesson/edit/${response.data.id}`;
      }).catch((error) => {
        this.$_errorSave(error);
        console.error('Error in create lesson query', error);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// New.vue?34fa3ae2